import { defaultPad } from './normalize/pad'
import { normalizeSettings } from './normalize/settings'
import { clone } from './normalize/utils'

export const initialState = {
  user: null,
  wallets: {},
  coins: {},
  coinsStats: {},
  mints: {},
  mintsStats: {},
  uiPluginInstallations: [],
  positionLifecycles: [],
  recentMarketTrades: [],
  installationsReady: false,
  liveReady: false,
  pnl: {},
  settings: normalizeSettings(),
  pad: defaultPad(),
}

export function makeState() {
  return clone(initialState)
}
